import React from "react";
import Image from "next/image";
import ArrowRight from "@/components/svg/arrowRight";
import { ChainData } from "@/constants/chain-details";

interface BridgingHeaderProps {
  originChain?: ChainData;
  destinationChain?: ChainData;
}

const BridgingHeader: React.FC<BridgingHeaderProps> = ({
  originChain,
  destinationChain
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
      {originChain && (
        <>
          <Image
            src={originChain.logo}
            alt={`${originChain.chainName} logo`}
            width={24}
            height={24}
          />
          <b>{originChain.chainName}</b>
        </>
      )}
      <ArrowRight style={{ margin: '0 4px' }} />
      {destinationChain && (
        <>
          <Image
            src={destinationChain.logo}
            alt={`${destinationChain.chainName} logo`}
            width={24}
            height={24}
          />
          <b>{destinationChain.chainName}</b>
        </>
      )}
    </div>
  );
};

export default BridgingHeader;
